import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scrollt bei jeder Änderung des Pfades (pathname) nach oben
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;